import type { CodeExpr, ErrorCode } from "@kex-resources/api-errors";

import type { QueryApiError, SubmitFormError } from "../types";

export const makeQueryApiError = <
  Group extends CodeExpr,
  Code extends ErrorCode,
  Payload extends Record<string, unknown>,
>(
  group: Group,
  code: Code,
  payload?: Payload,
): QueryApiError<Group, ErrorCode> => {
  return {
    code,
    group,
    payload,
  };
};

export const makeSubmitFormError = <
  Group extends CodeExpr,
  Code extends ErrorCode,
  Payload extends Record<string, unknown>,
  FieldName extends string,
>(
  group: Group,
  code: Code,
  fieldNames: FieldName[],
  fieldErrorMessage: Partial<Record<FieldName, string>>,
  payload?: Payload,
): SubmitFormError<Group, Code, FieldName> => {
  return {
    code,
    fieldErrorMessage,
    fieldNames,
    group,
    payload,
  };
};
